import React, { PropsWithChildren } from 'react';
import { StyledBottombar, StyledBottombarWrapper } from './Bottombar.style';

const Bottombar: React.FC<PropsWithChildren> = (props) => {
  return (
    <StyledBottombarWrapper className="styled-fixed-sidebar">
      <StyledBottombar>{props.children}</StyledBottombar>
    </StyledBottombarWrapper>
  );
};

export default Bottombar;
